<style lang="scss" scoped>
    ::v-deep .bar,
    ::v-deep .bar-button {
        // height: inherit !important;
        height: 100%;
        background-image: none;
        color: white !important;
        background-color: #d76633 !important;
    }

    ::v-deep .bar {
        width: 50%;
    }

    ::v-deep .bar-button {
        width: 100% !important;
    }

    ::v-deep .bar-button .label {
        font-size: 15px;
        // font-weight: bold;
        letter-spacing: 0.5px;
        font-weight: 500;

    }

    ::v-deep .bar-button > .bar-menu {
        width: 150%;
    }

    ::v-deep .bar-menu {
        // width: 100%;
        font-family: "Quattrocento Sans", sans-serif;
        // @extend .font-quattrocento;
    }

    ::v-deep .bar-menu-items {
        // width: 100%;
    }

    ::v-deep .bar-menu-item {
        // width: 100%;w
    }

    ::v-deep .bar-menu-item .label {
        font-size: 1.0em;
    }
</style>

<template>
  <div>
    <BModal id="add-session-modal" title="Add New Training Session" v-model="isAddSessionModalVisible" centered size="xl" hide-footer :static="true"
    >
      <template #default>
        <add-training-session
          dusk="add-training-session-component"
          :training-id="trainingId"
          :new-session="newSession"
          @add-new-session="closeNewSessionModal"
        ></add-training-session>
      </template>
    </BModal>

     <vue-file-toolbar-menu :content="menu" class="btn btn-orange-blue"></vue-file-toolbar-menu>
  </div>
</template>

<script>
    import VueFileToolbarMenu from 'vue-file-toolbar-menu';
    import AddTrainingSession from './AddTrainingSession';
    import { computed } from 'vue'; // Import computed from Vue 3
    import { useStore } from 'vuex'; // Import useStore from Vue 3's Vuex

    export default{
        components: {
            'vue-file-toolbar-menu' : VueFileToolbarMenu,
            'add-training-session': AddTrainingSession,
        },
        props: {
            trainingId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                newSession: true,
                isAddSessionModalVisible: false
            }
        },
        methods: {
            getSessionMenu(session) {
                let vm = this;
                return {
                    text: session.title ? this.truncateTitle(session.title, 15) : "Session on " + this.formatDate(session.start_time),
                    class: "session-title-menu-item" + (session.isNew ? " new" : ""),
                    // id: "session-title-menu-item-" + session.id,
                    menu: [
                        {
                            text: "Play Video",
                            class: "play-video-menu-item",
                            icon: "ondemand_video",
                            click: () => {
                                vm.$emit('select-content', 'panopto-video-embed', vm.trainingId, session.id);
                            }
                        }, {
                            text: "Knowledge Quiz",
                            class: "knowledge-quiz-menu-item",
                            icon: "list_alt",
                            disabled: vm.latestQuizResponses[session.id] ? vm.latestQuizResponses[session.id].status == "Completed" : false,
                            click: () => {
                                if(!this.disabled) {
                                    vm.$emit('select-content', 'provider-training-knowledge-quiz', vm.trainingId, session.id);
                                }
                            }
                        }, {
                            text: "Evaluation",
                            class: "evaluation-menu-item",
                            icon: "question_answer",
                            disabled: vm.latestEvaluationResponses[session.id] ? vm.latestEvaluationResponses[session.id].status == "Completed" : false,
                            click: () => {
                                if(!this.disabled) {
                                    vm.$emit('select-content', 'provider-training-evaluation', vm.trainingId, session.id);
                                }
                            }
                        }
                    ]
                };
            },
            formatDate: function (value) {
                if (value) {
                    return moment(value).format('MM/DD/YY');
                }
                return "";
            },
            closeNewSessionModal: function() {
                //this.$refs.newSessionModal.hide();
                this.newSession = false;
                this.isAddSessionModalVisible = false;
            },
            truncateTitle(title, length=30) {
                if(!title) {
                    title = "Unnamed Session";
                }
                if(title.length > length) {
                    return title.substring(0,length) + "...";
                }
                return title;
            },
        },
        computed: {
            menu: function() {
                let vm = this;

                let menu = [{ 
                    text: "Start", 
                    menu: vm.sessionMenus.concat([
                        {
                            text: "Start New Session",
                            class: "start-new-session-menu-item",
                            icon: "library_add",
                            click: () => {
                                this.isAddSessionModalVisible = true;
                                this.newSession = true;
                                //vm.$refs.newSessionModal.show();
                            }
                        }
                    ]),
                }];

                return menu;
            },
            sessionMenus: function() {
                let menus = [];
                for(const session of this.trainingSessionsForMenu) {
                    menus.push(this.getSessionMenu(session));
                }
                return menus;
            },
            trainingSessionsForMenu: function() {
                return this.$store.getters.trainingSessionsForTraining(this.trainingId).filter((s,i) => {
                    return !s.is_finalized;
                });
            },
            latestEvaluationResponses: function()  {
              return this.$store.state.latestEvaluationResponses;
            },
            latestQuizResponses: function()  {
              return this.$store.state.latestQuizResponses;
            },
        },
    }
</script>